"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScreenBase = void 0;
var react_1 = __importStar(require("react"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var WorkflowCardBody_1 = require("../../components/WorkflowCard/WorkflowCardBody");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var cybersecurity_certified_png_1 = __importDefault(require("../../assets/images/cybersecurity_certified.png"));
var components_1 = require("../../components");
var Button_1 = __importDefault(require("@mui/material/Button"));
var styles_1 = require("@mui/material/styles");
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var constants_1 = require("../../utils/constants");
var utilityClasses_1 = require("./utilityClasses");
var base_1 = require("@mui/base");
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
var styles_2 = require("../../styles");
/**
 * Component that renders a login screen that prompts a user to enter a username and password to login.
 *
 * @param usernameLabel label for the username field
 * @param usernameTextFieldProps props to pass to the username text field
 * @param usernameValidator function used to validate the username
 * @param initialUsernameValue username used to pre-populate the field
 * @param passwordLabel label for the password field
 * @param passwordTextFieldProps props to pass to the password text field
 * @param passwordValidator function used to validate the password
 * @param showRememberMe whether or not to show the 'remember me' checkbox
 * @param rememberMeLabel label for the 'remember me' checkbox
 * @param rememberMeInitialValue whether or not the 'remember me' checkbox should be checked by default
 * @param onRememberMeChanged callback function that is called when the 'remember me' checkbox is changed
 * @param loginButtonLabel label for the login button
 * @param onLogin callback function that is called when the login button is clicked
 * @param showForgotPassword whether or not to show the 'forgot password' link
 * @param forgotPasswordLabel label for the 'forgot password' link
 * @param onForgotPassword callback function that is called when the 'forgot password' link is clicked
 * @param showSelfRegistration whether or not to show the 'self registration' link
 * @param selfRegisterButtonLabel label for the 'self registration' link
 * @param selfRegisterInstructions instructions for the 'self registration' link
 * @param onSelfRegister callback function that is called when the 'self registration' link is clicked
 * @param showContactSupport whether or not to show the 'contact support' link
 * @param contactSupportLabel label for the 'contact support' link
 * @param onContactSupport callback function that is called when the 'contact support' link is clicked
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param showCyberSecurityBadge whether or not to show the cyber security badge
 * @param projectImage image to display at the top of the screen
 * @param header header to display at the top of the screen
 * @param footer footer to display at the bottom of the screen
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 *
 * @category Component
 */
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        projectImageWrapper: ['projectImageWrapper'],
        inputFieldsWrapper: ['inputFieldsWrapper'],
        usernameTextField: ['usernameTextField'],
        passwordTextField: ['passwordTextField'],
        rememberMeLoginRowWrapper: ['rememberMeLoginRowWrapper'],
        rememberMeWrapper: ['rememberMeWrapper'],
        rememberMeCheckbox: ['rememberMeCheckbox'],
        rememberMeLabel: ['rememberMeLabel'],
        loginButtonWrapper: ['loginButtonWrapper'],
        loginButton: ['loginButton'],
        forgotPasswordWrapper: ['forgotPasswordWrapper'],
        forgotPasswordLabel: ['forgotPasswordLabel'],
        selfRegisterWrapper: ['selfRegisterWrapper'],
        selfRegisterInstructionLabel: ['selfRegisterInstructionLabel'],
        selfRegisterLabel: ['selfRegisterLabel'],
        contactSupportWrapper: ['contactSupportWrapper'],
        contactSupportLabel: ['contactSupportLabel'],
        cyberSecurityBadgeWrapper: ['cyberSecurityBadgeWrapper'],
        cyberSecurityBadge: ['cyberSecurityBadge'],
    };
    return (0, base_1.unstable_composeClasses)(slots, utilityClasses_1.getLoginScreenUtilityClass, classes);
};
var LoginScreenBase = function (props) {
    var _a;
    var usernameLabel = props.usernameLabel, usernameTextFieldProps = props.usernameTextFieldProps, usernameValidator = props.usernameValidator, initialUsernameValue = props.initialUsernameValue, passwordLabel = props.passwordLabel, passwordTextFieldProps = props.passwordTextFieldProps, passwordValidator = props.passwordValidator, showRememberMe = props.showRememberMe, rememberMeLabel = props.rememberMeLabel, rememberMeInitialValue = props.rememberMeInitialValue, onRememberMeChanged = props.onRememberMeChanged, loginButtonLabel = props.loginButtonLabel, onLogin = props.onLogin, showForgotPassword = props.showForgotPassword, forgotPasswordLabel = props.forgotPasswordLabel, onForgotPassword = props.onForgotPassword, showSelfRegistration = props.showSelfRegistration, selfRegisterButtonLabel = props.selfRegisterButtonLabel, selfRegisterInstructions = props.selfRegisterInstructions, onSelfRegister = props.onSelfRegister, showContactSupport = props.showContactSupport, contactSupportLabel = props.contactSupportLabel, onContactSupport = props.onContactSupport, errorDisplayConfig = props.errorDisplayConfig, showCyberSecurityBadge = props.showCyberSecurityBadge, projectImage = props.projectImage, header = props.header, footer = props.footer, otherProps = __rest(props, ["usernameLabel", "usernameTextFieldProps", "usernameValidator", "initialUsernameValue", "passwordLabel", "passwordTextFieldProps", "passwordValidator", "showRememberMe", "rememberMeLabel", "rememberMeInitialValue", "onRememberMeChanged", "loginButtonLabel", "onLogin", "showForgotPassword", "forgotPasswordLabel", "onForgotPassword", "showSelfRegistration", "selfRegisterButtonLabel", "selfRegisterInstructions", "onSelfRegister", "showContactSupport", "contactSupportLabel", "onContactSupport", "errorDisplayConfig", "showCyberSecurityBadge", "projectImage", "header", "footer"]);
    var theme = (0, styles_1.useTheme)();
    var defaultClasses = useUtilityClasses(props);
    var _b = react_1.default.useState(initialUsernameValue || ''), username = _b[0], setUsername = _b[1];
    var _c = react_1.default.useState(''), password = _c[0], setPassword = _c[1];
    var _d = react_1.default.useState(rememberMeInitialValue), rememberMe = _d[0], setRememberMe = _d[1];
    var _e = react_1.default.useState(false), shouldValidateUsername = _e[0], setShouldValidateUsername = _e[1];
    var _f = react_1.default.useState(false), shouldValidatePassword = _f[0], setShouldValidatePassword = _f[1];
    var passwordField = (0, react_1.useRef)(null);
    var _g = (0, react_1.useState)(usernameValidator ? usernameValidator(username) : true), isUsernameValid = _g[0], setIsUsernameValid = _g[1];
    var _h = (0, react_1.useState)(passwordValidator ? passwordValidator(password) : true), isPasswordValid = _h[0], setIsPasswordValid = _h[1];
    var _j = (0, react_1.useState)(isUsernameValid === true ? '' : isUsernameValid), usernameError = _j[0], setUsernameError = _j[1];
    var _k = (0, react_1.useState)(isPasswordValid === true ? '' : isPasswordValid), passwordError = _k[0], setPasswordError = _k[1];
    var handleUsernameInputChange = (0, react_1.useCallback)(function (value) {
        setUsername(value);
        var validatorResponse = usernameValidator === null || usernameValidator === void 0 ? void 0 : usernameValidator(value);
        setIsUsernameValid(typeof validatorResponse === 'boolean' ? validatorResponse : false);
        setUsernameError(typeof validatorResponse === 'string' ? validatorResponse : '');
    }, [usernameValidator]);
    var handlePasswordInputChange = (0, react_1.useCallback)(function (value) {
        setPassword(value);
        var validatorResponse = passwordValidator === null || passwordValidator === void 0 ? void 0 : passwordValidator(value);
        setIsPasswordValid(typeof validatorResponse === 'boolean' ? validatorResponse : false);
        setPasswordError(typeof validatorResponse === 'string' ? validatorResponse : '');
    }, [passwordValidator]);
    var handleLogin = function () {
        if (onLogin)
            void onLogin(username, password, rememberMe);
    };
    var handleForgotPassword = function () {
        if (onForgotPassword)
            onForgotPassword();
    };
    var handleSelfRegister = function () {
        if (onSelfRegister)
            onSelfRegister();
    };
    var handleContactSupport = function () {
        if (onContactSupport)
            onContactSupport();
    };
    var handleRememberMeChanged = function (value) {
        if (onRememberMeChanged) {
            onRememberMeChanged(value);
            setRememberMe(value);
        }
    };
    var isFormValid = function () {
        return typeof isUsernameValid === 'boolean' &&
            isUsernameValid &&
            typeof isPasswordValid === 'boolean' &&
            isPasswordValid;
    };
    var handleLoginSubmit = function (e) {
        if (e.key === 'Enter' && isFormValid()) {
            void handleLogin();
        }
    };
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({ className: defaultClasses.root, "data-testid": defaultClasses.root }, otherProps),
        react_1.default.createElement(WorkflowCardBody_1.WorkflowCardBody, { sx: { py: { xs: 4, sm: 4, md: 4 }, px: { xs: 4, sm: 8, md: 8 } } },
            header,
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', maxWidth: '100%', mb: 6 }, className: defaultClasses.projectImageWrapper, "data-testid": defaultClasses.projectImageWrapper }, projectImage),
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }, className: defaultClasses.inputFieldsWrapper, "data-testid": defaultClasses.inputFieldsWrapper },
                    react_1.default.createElement(Box_1.default, { sx: (_a = {
                                width: '100%',
                                mb: username.length > 0 && !isUsernameValid && shouldValidateUsername
                                    ? 4
                                    : "".concat((parseInt(theme.spacing(4)) + constants_1.HELPER_TEXT_HEIGHT).toString(), "px")
                            },
                            _a[theme.breakpoints.down('sm')] = {
                                mb: username.length > 0 && !isUsernameValid && shouldValidateUsername
                                    ? 3
                                    : "".concat((parseInt(theme.spacing(3)) + constants_1.HELPER_TEXT_HEIGHT).toString(), "px"),
                            },
                            _a) },
                        react_1.default.createElement(TextField_1.default, __assign({ fullWidth: true, id: "username", className: defaultClasses.usernameTextField, "data-testid": defaultClasses.usernameTextField, label: usernameLabel || 'Username', name: "username", variant: "filled", value: username, error: shouldValidateUsername && !isUsernameValid, helperText: shouldValidateUsername && !isUsernameValid ? usernameError : '' }, usernameTextFieldProps, { onChange: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (usernameTextFieldProps === null || usernameTextFieldProps === void 0 ? void 0 : usernameTextFieldProps.onChange) && usernameTextFieldProps.onChange(e);
                                handleUsernameInputChange(e.target.value);
                            }, onSubmit: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (usernameTextFieldProps === null || usernameTextFieldProps === void 0 ? void 0 : usernameTextFieldProps.onSubmit) && usernameTextFieldProps.onSubmit(e);
                                if (e.key === 'Enter' && passwordField.current)
                                    passwordField.current.focus();
                            }, onBlur: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (usernameTextFieldProps === null || usernameTextFieldProps === void 0 ? void 0 : usernameTextFieldProps.onBlur) && usernameTextFieldProps.onBlur(e);
                                setShouldValidateUsername(true);
                            }, onKeyUp: function (e) {
                                if (e.key === 'Enter' && passwordField.current)
                                    passwordField.current.focus();
                            } }))),
                    react_1.default.createElement(Box_1.default, { sx: {
                            width: '100%',
                            mb: username.length > 0 && !isPasswordValid && shouldValidatePassword
                                ? 2
                                : "".concat((parseInt(theme.spacing(2)) + constants_1.HELPER_TEXT_HEIGHT).toString(), "px"),
                        } },
                        react_1.default.createElement(components_1.PasswordTextField, __assign({ fullWidth: true, inputRef: passwordField, id: "password", className: defaultClasses.passwordTextField, "data-testid": defaultClasses.passwordTextField, name: "password", label: passwordLabel || 'Password', variant: "filled", value: password, error: shouldValidatePassword && !isPasswordValid, helperText: shouldValidatePassword && !isPasswordValid ? passwordError : '' }, passwordTextFieldProps, { onChange: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onChange) && passwordTextFieldProps.onChange(e);
                                handlePasswordInputChange(e.target.value);
                            }, onSubmit: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onSubmit) && passwordTextFieldProps.onSubmit(e);
                                handleLoginSubmit(e);
                            }, onBlur: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onBlur) && passwordTextFieldProps.onBlur(e);
                                setShouldValidatePassword(true);
                            }, onKeyUp: function (e) {
                                // eslint-disable-next-line no-unused-expressions
                                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onSubmit) && passwordTextFieldProps.onSubmit(e);
                                handleLoginSubmit(e);
                            } }))))),
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    mt: 1,
                    mb: 5,
                    flexWrap: { md: 'nowrap', sm: 'wrap' },
                    flexDirection: { md: 'row', sm: 'column' },
                    justifyContent: { md: 'space-between', sm: 'center' },
                }, className: defaultClasses.rememberMeLoginRowWrapper, "data-testid": defaultClasses.rememberMeLoginRowWrapper },
                showRememberMe && (react_1.default.createElement(Box_1.default, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        ml: -1.5,
                        mr: { md: 1, sm: 0 },
                    }, className: defaultClasses.rememberMeWrapper, "data-testid": defaultClasses.rememberMeWrapper },
                    react_1.default.createElement(Checkbox_1.default, { color: "primary", checked: rememberMe, onChange: function (e) { return handleRememberMeChanged(e.target.checked); }, className: defaultClasses.rememberMeCheckbox, "data-testid": defaultClasses.rememberMeCheckbox }),
                    react_1.default.createElement(Typography_1.default, { variant: "body1", className: defaultClasses.rememberMeLabel, "data-testid": defaultClasses.rememberMeLabel }, rememberMeLabel || 'Remember Me'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'flex-end',
                        width: showRememberMe ? 'auto' : '100%',
                    }, className: defaultClasses.loginButtonWrapper, "data-testid": defaultClasses.loginButtonWrapper },
                    react_1.default.createElement(Button_1.default, { className: defaultClasses.loginButton, "data-testid": defaultClasses.loginButton, onClick: handleLogin, disabled: !isFormValid(), variant: "contained", color: "primary", sx: {
                            width: showRememberMe ? 150 : '100%',
                        } }, loginButtonLabel || 'Log In'))),
            showForgotPassword && (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center', textAlign: 'center' }, className: defaultClasses.forgotPasswordWrapper, "data-testid": defaultClasses.forgotPasswordWrapper },
                react_1.default.createElement(Typography_1.default, { variant: "body2", sx: styles_2.LinkStyles, onClick: handleForgotPassword, className: defaultClasses.forgotPasswordLabel, "data-testid": defaultClasses.forgotPasswordLabel }, forgotPasswordLabel || 'Forgot your password?'))),
            showSelfRegistration && (react_1.default.createElement(Box_1.default, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: 4,
                    textAlign: 'center',
                }, className: defaultClasses.selfRegisterWrapper, "data-testid": defaultClasses.selfRegisterWrapper },
                react_1.default.createElement(Typography_1.default, { variant: "body2", className: defaultClasses.selfRegisterInstructionLabel, "data-testid": defaultClasses.selfRegisterInstructionLabel }, selfRegisterInstructions || 'Need an account?'),
                react_1.default.createElement(Typography_1.default, { variant: "body2", sx: styles_2.LinkStyles, onClick: handleSelfRegister, className: defaultClasses.selfRegisterLabel, "data-testid": defaultClasses.selfRegisterLabel }, selfRegisterButtonLabel || 'Register now!'))),
            showContactSupport && (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center', marginTop: 4, textAlign: 'center' }, className: defaultClasses.contactSupportWrapper, "data-testid": defaultClasses.contactSupportWrapper },
                react_1.default.createElement(Typography_1.default, { variant: "body2", sx: styles_2.LinkStyles, onClick: handleContactSupport, className: defaultClasses.contactSupportLabel, "data-testid": defaultClasses.contactSupportLabel }, contactSupportLabel || 'Contact Support'))),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } }, footer),
            showCyberSecurityBadge && (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center', marginTop: 2 }, className: defaultClasses.cyberSecurityBadgeWrapper, "data-testid": defaultClasses.cyberSecurityBadgeWrapper },
                react_1.default.createElement("img", { className: defaultClasses.cyberSecurityBadge, "data-testid": defaultClasses.cyberSecurityBadge, src: cybersecurity_certified_png_1.default, alt: "Cyber Security Badge", style: { width: '100px' } }))))));
};
exports.LoginScreenBase = LoginScreenBase;
